import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const LensLineageCountsFragmentGql: DocumentNode = gql`
fragment LensLineageCountsFragment on Lens {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  fieldsConnection {
    totalCount
  }
}
`;
